import { render } from "./Sesiones.vue?vue&type=template&id=6b980d40"
import script from "./Sesiones.vue?vue&type=script&lang=js"
export * from "./Sesiones.vue?vue&type=script&lang=js"

import "./Sesiones.vue?vue&type=style&index=0&id=6b980d40&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__